module.exports = __webpack_public_path__ + "img/process.ff9bade3.svg";